import styles from "./styles";

const CompetitionInfo = () => (
  <div className={styles.container}>
    <h2 className="app_barnsley5">WIN TICKETS TO THE BRITS</h2>
    <h2 className="app_barnsley5">
      Grab four tix to The BRIT Awards 2024 c/o Mastercard - plus, loads more
      prizes!
    </h2>
    <p className="app_london1">
      {`One lucky winner will get a Diamond ticket for themself and three
      friends to attend The BRIT Awards - we're talking Level 1 seating, dinner,
      drinks and an exclusive invite to the after-party. And in true ASOS
      fashion, we'll even make sure you look the part with styling from our
      Fashion Team AND a London hotel stay!`}
    </p>
    <p className="app_london1">
      Also, there are hundreds of £150 ASOS vouchers up for grabs!
    </p>
    <p className="app_london1">
      For a chance to win, fill in your details below and shop ASOS with your
      Mastercard👇
    </p>
    <p className="app_london1">
      The BRIT Awards 2024 with Mastercard takes place on 2 March 2024 at The O2
      arena, exclusively broadcast on ITVX and ITV Hub. The BRIT Awards prizes
      courtesy of Mastercard.
    </p>
    <p className="app_london1">
      You will need to make a purchase by checking out directly with a valid
      Mastercard, (i.e. payment made using digital wallets such as ApplePay,
      Google Pay, Samsung Pay, PayPal will not count) to take part in this
      promotion.
    </p>
    <p className="app_london1">
      Check out our{" "}
      <a href="https://www.asos.com/discover/marketing-terms-and-conditions/190110-mastercard-terms/">
        Ts&Cs here
      </a>
      .
    </p>
  </div>
);

export default CompetitionInfo;
